import { render, staticRenderFns } from "./MyPosition.vue?vue&type=template&id=2cc855f3&scoped=true&"
import script from "./MyPosition.vue?vue&type=script&lang=js&"
export * from "./MyPosition.vue?vue&type=script&lang=js&"
import style0 from "./MyPosition.vue?vue&type=style&index=0&id=2cc855f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc855f3",
  null
  
)

export default component.exports